import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Layout from '../components/layout'
import Company from '../components/company'
import { Link } from 'gatsby'
import getSharingImage from '@jlengstorf/get-share-image'

class CompanyTemplate extends React.Component {
  render() {
    var node = get(this, 'props.pageContext.node')
    var company = node.data

    var color = 'rgb(211, 232, 225)'
    var name = company.Name
    var title = 'Jobs at ' + name
    var team = ''
    if (company.Number_of_Team_Members) {
      team = team + company.Number_of_Team_Members + ' total '

      if (company.Number_of_Women) {
        team = team + '+ 👩 ' + company.Number_of_Women + ' women in tech '
      }
      if (company.Number_of_People_of_Color) {
        team =
          team +
          '+ 👩🏾 ' +
          company.Number_of_People_of_Color +
          ' people of color in tech '
      }
      if (company.Number_of_LGBTQIA_Individuals) {
        team =
          team +
          '+ 🌈 ' +
          company.Number_of_LGBTQIA_Individuals +
          ' LGBTQIA+ folks in tech '
      }
      if (company.Number_of_Disabled_Individuals) {
        team =
          team +
          ' ♿ ' +
          company.Number_of_Disabled_Individuals +
          ' disabled folks in tech '
      }
    }

    // var role = job.Role.replace(/ *\([^)]*\) */g, '')
    // var salary_range = job.Salary_Range ? '  •  ' + job.Salary_Range : ''
    var description = company.Diversity
      ? company.Diversity.substring(0, 250)
      : name

    const socialImage = getSharingImage({
      title: name + ' is hiring!',
      textLeftOffset: 70,
      taglineFontSize: 50,
      titleFontSize: 96,
      textAreaWidth: 1200,
      cloudName: 'dgyu2ja9g',
      imagePublicID: 'plain-job-template',
    })

    return (
      <Layout location={this.props.location} style={{ backgroundColor: color }}>
        <Helmet
          title={title}
          meta={[
            {
              property: 'title',
              content: title,
            },
            {
              property: 'description',
              content: description + '...',
            },

            { property: 'og:title', content: title },

            {
              property: 'og:description',
              content: description + '...',
            },
            {
              property: 'og:image',
              content: socialImage,
            },
            {
              name: 'twitter:title',
              content: title,
            },
            {
              name: 'twitter:description',
              content: description + '...',
            },
            { name: 'twitter:card', content: 'summary_large_image' },
            {
              name: 'twitter:image',
              content: socialImage,
            },
          ]}
        >
          <html lang="en" />
        </Helmet>

        <div className=" mx-auto max-w-screen-xl md:p-12 md:pt-4">
          {/* //headline */}
          <div className="text-center p-4">
            <h2 className="text-3xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-4xl sm:leading-none md:text-5xl">
              Job Board
              <br />
              <span className="text-teal-500">
                for underrepresented folks in tech
              </span>
            </h2>
            <p className="mt-3 max-w-md mx-auto text-base text-gray-600 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl leading-5" />
          </div>

          <div className="flex flex-wrap flex-wrap md:mt-4">
            <div className="w-full lg:w-2/3 xl:w-2/3">
              {/* job posting */}
              <Link
                to="/job-board"
                className="text-teal-600 text-base inline-block mt-4 ml-6 flex"
                rel="noopener noreferrer"
              >
                <svg
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="0.5"
                  viewBox="0 0 20 20"
                  className="w-4 h-4"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.70711 16.7071C9.31658 17.0976 8.68342 17.0976 8.29289 16.7071L2.29289 10.7071C1.90237 10.3166 1.90237 9.68342 2.29289 9.29289L8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289C10.0976 3.68342 10.0976 4.31658 9.70711 4.70711L5.41421 9H17C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11L5.41421 11L9.70711 15.2929C10.0976 15.6834 10.0976 16.3166 9.70711 16.7071Z"
                  />
                </svg>
                {'  '}
                Back to all jobs
              </Link>
              <div className="block relative md:m-6 rounded-lg overflow-hidden mt-6 ">
                <Company data={node.data} id={node.id} />
              </div>
            </div>
            <div className="w-full lg:w-1/3 xl:w-1/3">
              {/* //subscribe */}
              <br />
              <br />
              <div className="bg-white md:m-6 mb-6 p-6 border border-gray-300 leading-normal rounded-lg shadow-lg  text-gray-700">
                <div className="flex">
                  <div className="ml-4">
                    <p className="text-md font-bold">Be the first to know!</p>
                    <p>
                      We'll let you know as soon as a job is posted on our job
                      board.
                    </p>
                    <Link
                      to="https://www.diversifytech.co/join/?utm_source=job_posting&utm_medium=banner&utm_campaign=job_board"
                      className="text-teal-600 text-base inline-block mt-4 md:mt-0"
                      rel="noopener noreferrer"
                    >
                      Subscribe →
                    </Link>
                  </div>
                </div>

                <br />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default CompanyTemplate
